import { State } from "@/store/modules/admin/index";
const getOpenNewSpaceModal = (state: State): boolean => {
  return state.openNewSpaceModal;
};
export default {
  getOpenNewSpaceModal,
};
